import React from "react";
import './Header.css';
import kineticLogo  from '../../assets/img/kinetic-menu-logo.png';
import Hamburger from 'hamburger-react'


export default class Header extends React.Component {

	constructor(props){
		super(props)
		this.state = {
			isMenuOpen: false
		}
		this.escFunction = this.escFunction.bind(this)
	}

	componentDidMount(){
		window.addEventListener("keydown", this.escFunction, false);
	}

	componentWillUnmount(){
		window.removeEventListener("keydown", this.escFunction, false);
	}

	escFunction(event){
		if (event.key === "Escape" && this.state.isMenuOpen) {
			this.toggleMenu()
		}
	}




	render() {
		const TWITTER_URL="https://twitter.com/beyond_rarity"
		const LINKEDIN_URL="https://www.linkedin.com/company/kinetic-chain-llc/posts/?feedView=all"
		const MEDIUM_URL="https://medium.com/the-brr"

		return (
		<div className={this.state.isMenuOpen?"header-container open-menu":"header-container"}>

			<div className="upper-line-menu">
				<div className="kinetic-logo-container"><img src={kineticLogo} alt="" className="kinetic-menu-logo"/></div>

				<div className="social">
					<a href={TWITTER_URL} target="_blank" className="icon-wrapper twitter-logo" rel="noreferrer" >
					</a>
					<a href={LINKEDIN_URL} target="_blank" className="icon-wrapper linkedin-logo" rel="noreferrer" >
					</a>
					<a href={MEDIUM_URL} target="_blank" className="icon-wrapper medium-logo" rel="noreferrer" >
					</a>
				</div>
				<div className="menu-wrapper">
					<Hamburger color="#ff7317" size={20} toggled={this.state.isMenuOpen} toggle={()=>{this.toggleMenu()}} />

				</div>
			</div>
			<div className="menu-body">
				<div className="modal-menu-container">
					<div className="menu-body">
						<p className="section-title menu-item"><a href="#core-products" onClick={()=>{this.toggleMenu()}}>CORE PRODUCTS</a></p>
						<p className="section-title menu-item"><a href="#case-studies" onClick={()=>{this.toggleMenu()}}>CASE STUDIES</a></p>
						<p className="section-title menu-item"><a href="#kinetic-process" onClick={()=>{this.toggleMenu()}}>PROCESS</a></p>
						<p className="section-title menu-item"><a href="#kind-words" onClick={()=>{this.toggleMenu()}}>KIND WORDS</a></p>
						<p className="section-title menu-item"><a href="#publications" onClick={()=>{this.toggleMenu()}}>PULICATIONS</a></p>
						<p className="section-title menu-item"><a href="#team" onClick={()=>{this.toggleMenu()}}>TEAM</a></p>
						<p className="section-title menu-item"><a href="#contact" onClick={()=>{this.toggleMenu()}}>CONTACT</a></p>
					</div>
				</div>
			</div>






		</div>
		);
	}

	toggleMenu(e){
		this.setState({isMenuOpen:!this.state.isMenuOpen},()=>{
			document.body.parentElement.style.overflowY=this.state.isMenuOpen?"hidden":"unset"
			this.props.onOpen(this.state.isMenuOpen)
		})
	}
}
